var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-env browser */

import { parsePulseCookie } from '@spt-tracking/pulse-cis-sync';
import { isString } from './utils';
import device from './_device';

export * from './_device';

export default function (input) {
  var _ref = input || {},
      deviceData = _ref.device;

  var _parsePulseCookie = parsePulseCookie(),
      environmentId = _parsePulseCookie.environmentId,
      jwe = _parsePulseCookie.jwe;

  var data = _extends({
    id: environmentId,
    jweIds: jwe
  }, isString(deviceData) ? { id: deviceData } : deviceData);

  return device({ device: data });
}